import { render, staticRenderFns } from "./TransitionWrapper.vue?vue&type=template&id=97459872&scoped=true"
import script from "./TransitionWrapper.vue?vue&type=script&lang=js"
export * from "./TransitionWrapper.vue?vue&type=script&lang=js"
import style0 from "./TransitionWrapper.vue?vue&type=style&index=0&id=97459872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97459872",
  null
  
)

export default component.exports